export const LOGIN_ROOT = '/'